import React from 'react';
import { MapPin, Users, Sun, Leaf, Zap, Battery, Bike, TrendingUp, Award, Sparkles, Globe, Wrench } from 'lucide-react';
import { useSection } from '../../hooks/useSection';

const ICONS: Record<string, React.ComponentType<any>> = {
  MapPin, Users, Sun, Leaf, Zap, Battery, Bike, TrendingUp, Award, Sparkles, Globe, Wrench,
};

// Contenu par défaut (fallback si la section n'est pas administrée en base)
const DEFAULT_STATS = [
  { value: '4', unit: '', label: 'Stations', icon: 'MapPin' },
  { value: '10', unit: '+', label: 'Bénéficiaires formées', icon: 'Users' },
  { value: '100', unit: '%', label: 'Énergie solaire', icon: 'Sun' },
  { value: '1 000', unit: 't+', label: 'Tonnes CO₂ évitées', icon: 'Leaf' },
];

const ImpactStats: React.FC = () => {
  const { section } = useSection('home_impact_stats');
  if (section && section.is_visible === false) return null;

  const eyebrow = section?.subtitle || 'La confiance en chiffres';
  const stats = (section?.extra_data?.stats?.length ? section.extra_data.stats : DEFAULT_STATS) as Array<{ value: string; unit?: string; label: string; icon?: string }>;

  return (
    <section className="relative overflow-hidden border-y border-neutral-100 bg-white py-10 sm:py-12 lg:py-16">
      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-6 max-w-2xl text-center sm:mb-8">
          <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-primary-700 sm:text-xs">{eyebrow}</p>
          <h2 className="mt-2 text-2xl font-black tracking-[-0.025em] text-neutral-900 sm:text-3xl lg:text-4xl">
            {section?.title ? section.title : (<>L'impact <span className="text-primary-600">Proxy</span> aujourd'hui</>)}
          </h2>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4 lg:gap-6">
          {stats.map((stat, t) => {
            const Icon = (stat.icon && ICONS[stat.icon]) || MapPin;
            return (
              <div
                key={t}
                className="rounded-2xl bg-white p-4 ring-1 ring-neutral-200/80 shadow-[0_8px_24px_-12px_rgba(0,0,0,0.06)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_30px_-12px_rgba(0,0,0,0.1)] sm:p-5 lg:p-6"
              >
                <div className="mb-2 inline-flex h-8 w-8 items-center justify-center rounded-xl bg-primary-50 ring-1 ring-primary-100 sm:h-10 sm:w-10">
                  <Icon className="h-4 w-4 text-primary-600 sm:h-5 sm:w-5" strokeWidth={2.5} />
                </div>
                <div className="flex items-baseline gap-0.5">
                  <span className="text-3xl font-black tracking-tight text-neutral-900 sm:text-4xl lg:text-5xl">{stat.value}</span>
                  {stat.unit && <span className="text-lg font-bold text-neutral-500 sm:text-xl lg:text-2xl">{stat.unit}</span>}
                </div>
                <p className="mt-1 text-[10px] font-bold uppercase tracking-wider text-neutral-500 sm:text-xs">{stat.label}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ImpactStats;
